import { API_METHOD, ENDPOINTS } from './appConstants';
import { handleFetch } from './handleFetch';

const apiRoot = ENDPOINTS.API + '/elevatorCompany';

export const getAll = () => {   
    const options = {
        method: API_METHOD.GET
    };
    
    return handleFetch(apiRoot, options, true);
}
